<div class="trucking-grand-container" [ngClass]="{'ionic': useIonic,  'selectedroute' : routeId > 0 }">
    <div class="cards list">
        <div class="heading alineada-esquerra">
            <div class="principal-options">
                <div class="title">
                    {{'TRUCKING.COLUMN.ROUTES.TITLE' | translate}}
                </div>
            </div>

            <div class="line bar baroptions">
                <options class="smallpadding mixed-text-icon" [optionstrip]="filters"
                    (clickOption)="onFilterUpdate($event)">
                </options>
            </div>

            <div class="line actions">
                <div class="search-count">
                    <input class="searchbox" placeholder="{{'SEARCH'| translate}}" type=text [(ngModel)]="searchText"
                        (ngModelChange)="this.searchTextUpdate.next($event)" (focus)="onSearchFocus($event)"
                        (click)="onSearchClick($event)">
                    <span class="count">{{filterMetadata.count}}/{{routesCount}}</span>
                </div>
                <actions [actionstrip]="actions" (clickAction)="onClickAction($event)">
                </actions>
            </div>
        </div>

        <div class="page">
            <div class="column">
                <div class="llista">
                    <div class="overflow">
                        <shared-trucking-route-card
                            *ngFor="let item of routesExactKey | filterActiveRoutes:searchText2:filterMetadataExactKey | orderbytruckingroutecarddto:true; let i=index"
                            class="routeItem no-additional-info"
                            [ngClass]="{'selected':selectedRoute!=null && item.routeId==selectedRoute.routeId}"
                            [route]="item" (click)="onClickItem(item)" (clickBack)="onClickBack($event)">
                        </shared-trucking-route-card>

                        <shared-trucking-route-card
                            *ngFor="let item of getRoutes() | filterActiveRoutes:searchText2:filterMetadata | filterRemoveRepeat:routesExactKey:'routeId' | orderbytruckingroutecarddto:true | slice:0:sliceCount; let i=index"
                            class="routeItem no-additional-info"
                            [ngClass]="{'selected':selectedRoute!=null && item.routeId==selectedRoute.routeId}"
                            [route]="item" (click)="onClickItem(item)" (clickBack)="onClickBack($event)">
                        </shared-trucking-route-card>

                        <button class="slice-button" (click)="onSliceMore()" *ngIf="sliceCount<itemsCount">
                            {{'GENERAL.SLICE.BUTTON' | translate:{ sliceCount: sliceCount, itemsCount:itemsCount} }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>